<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { PDF_FORM, CUSTOMER_FORM } from '@/constants';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import HTMLEditor from '@/components/common/HTMLEditor.vue';

const props = defineProps<{
  item: object;
  typeForm: string;
}>();

const emits = defineEmits<{ 'update:item': [value: any] }>();

const { t } = useI18n({ useScope: 'global' });

const itemDetail = computed({
  get() {
    return props.item;
  },
  set(value) {
    emits('update:item', value);
  }
});

const getHeader = (dataType: string) => {
  switch (props.typeForm) {
    case PDF_FORM:
      if (dataType == 'intro') {
        return t('common.intro_paragraph');
      } else {
        return t('promos.labels.term');
      }
    case CUSTOMER_FORM:
      if (dataType == 'intro') {
        return t('common.intro_paragraph_on_quote_form');
      } else {
        return t('common.tab_comment_on_quote');
      }
    default:
      if (dataType == 'intro') {
        return t('common.intro_request_to_book');
      } else {
        return t('common.request_to_book_content');
      }
  }
};
</script>

<template>
  <div class="text-area">
    <Splitter layout="horizontal">
      <SplitterPanel :size="50" class="p-3">
        <div class="intro-content">
          <div class="intro-en mt-4">
            <h5>{{ $t('promos.labels.english') + ' - ' + getHeader('intro') }}</h5>
            <HTMLEditor v-model="itemDetail.intro" class="custom-editor mb-1" :placeholder="$t('common.intro')" />
          </div>
          <div class="intro-fr mt-4">
            <h5>{{ $t('promos.labels.french') + ' - ' + getHeader('intro') }}</h5>
            <HTMLEditor v-model="itemDetail.introFr" class="custom-editor mb-1" :placeholder="$t('common.intro')" />
          </div>
        </div>
      </SplitterPanel>
      <SplitterPanel :size="50" class="p-3">
        <div class="terms-content">
          <div class="term-en mt-4">
            <h5>{{ $t('promos.labels.english') + ' - ' + getHeader('term') }}</h5>
            <HTMLEditor v-model="itemDetail.terms" class="custom-editor mb-1" :placeholder="$t('management.term_and_condition')" />
          </div>
          <div class="term-fr mt-4">
            <h5>{{ $t('promos.labels.french') + ' - ' + getHeader('term') }}</h5>
          </div>
          <HTMLEditor v-model="itemDetail.termsFr" class="custom-editor mb-1" :placeholder="$t('management.term_and_condition')" />
        </div>
      </SplitterPanel>
    </Splitter>
  </div>
</template>
